module.exports = "/src/views/player/help/images/post.jpg";